export interface ArticleMeta {
  slug: string;
  image: string;
  icon: string;
}

export const articlesMeta: ArticleMeta[] = [
  {
    slug: "basetao-spreadsheet-guide",
    icon: "ri-table-2",
    image:
      "https://readdy.ai/api/search-image?query=A%20laptop%20displaying%20a%20neat%20spreadsheet%20beside%20a%20few%20folded%20clothing%20items%20and%20a%20coffee%20cup%20on%20a%20soft%20cream%20desk%20with%20warm%20natural%20light%20and%20clean%20minimal%20composition&width=1200&height=800&seq=article-spreadsheet&orientation=landscape",
  },
  {
    slug: "basetao-review",
    icon: "ri-star-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20handwritten%20review%20checklist%20with%20five%20gold%20stars%20next%20to%20product%20photos%20of%20sneakers%20and%20a%20hoodie%20on%20a%20soft%20sage%20green%20surface%20with%20gentle%20lighting%20and%20airy%20space&width=1200&height=800&seq=article-review&orientation=landscape",
  },
  {
    slug: "basetao-shipping-cost",
    icon: "ri-ship-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20cardboard%20shipping%20boxes%20packing%20tape%20and%20a%20calculator%20on%20a%20soft%20sand%20beige%20surface%20with%20warm%20lighting%20and%20clean%20minimal%20styling&width=1200&height=800&seq=article-shipping&orientation=landscape",
  },
  {
    slug: "basetao-coupon",
    icon: "ri-coupon-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20close-up%20of%20a%20paper%20discount%20coupon%20with%20a%20dashed%20edge%20next%20to%20folded%20clothing%20on%20a%20soft%20blush%20pink%20surface%20with%20bright%20fresh%20lighting%20and%20clean%20composition&width=1200&height=800&seq=article-coupon&orientation=landscape",
  },
  {
    slug: "basetao-discount-code",
    icon: "ri-percent-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20promo%20code%20screen%20next%20to%20a%20small%20shopping%20bag%20on%20a%20soft%20mint%20green%20surface%20with%20clean%20modern%20lighting%20and%20minimal%20styling&width=1200&height=800&seq=article-discount&orientation=landscape",
  },
  {
    slug: "basetao-warehouse",
    icon: "ri-archive-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20tidy%20warehouse%20shelf%20with%20labeled%20cardboard%20boxes%20and%20a%20clipboard%20in%20the%20foreground%20on%20a%20warm%20neutral%20background%20with%20soft%20industrial%20lighting%20and%20clean%20styling&width=1200&height=800&seq=article-warehouse&orientation=landscape",
  },
  {
    slug: "basetao-legit",
    icon: "ri-shield-check-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20shiny%20green%20shield%20with%20a%20white%20checkmark%20beside%20a%20padlock%20on%20a%20soft%20terracotta%20backdrop%20with%20warm%20reassuring%20lighting%20and%20clean%20minimal%20composition&width=1200&height=800&seq=article-legit&orientation=landscape",
  },
  {
    slug: "how-to-find-products",
    icon: "ri-search-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20large%20magnifying%20glass%20over%20a%20spread%20of%20product%20photos%20of%20shoes%20bags%20and%20clothing%20on%20a%20soft%20butter%20yellow%20surface%20with%20bright%20fresh%20lighting&width=1200&height=800&seq=article-find&orientation=landscape",
  },
  {
    slug: "basetao-seller-guide",
    icon: "ri-store-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20storefront%20counter%20with%20a%20friendly%20seller%20handing%20over%20a%20shopping%20bag%20on%20a%20warm%20camel%20brown%20backdrop%20with%20cozy%20lighting%20and%20clean%20styling&width=1200&height=800&seq=article-seller&orientation=landscape",
  },
  {
    slug: "basetao-qc-guide",
    icon: "ri-zoom-in-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20close-up%20of%20hands%20inspecting%20the%20seams%20of%20a%20folded%20garment%20with%20a%20magnifying%20glass%20on%20a%20soft%20light%20green%20surface%20with%20clean%20bright%20lighting&width=1200&height=800&seq=article-qc&orientation=landscape",
  },
];